export const Category = {
    user_detail: 'user-detail',
    navigation: 'navigation',
};

export const Action = {
    set_user_role: 'set-user-role',
    set_user_role_id: 'set-user-role_id',
    set_username: 'set-user-name',
    visit_page: 'visit-page',
};

export const Label = {
    user_role: 'user-role',
    user_role_id: 'user-role-id',
};
